// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","701":"aabda8d5","894":"b74ed73a"}[chunkId] + ".chunk.js";
};